import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession'
import { updateSession } from '../../lib/funnels/functions/v1/default/updateSession'
import { getFunnelFromUrl } from '../../lib/funnels/functions/v1/default/getFunnelFromUrl'
import { getSessionValue } from '../../lib/funnels/functions/v1/default/getSessionValue'
import { getDataFromSubmitEvent } from '../../lib/funnels/functions/v1/default/getDataFromSubmitEvent'
import { checkSubmitInputs } from '../../lib/funnels/functions/v1/default/checkSubmitInputs'
import { stripPhone } from '../../lib/funnels/functions/v1/default/stripPhone'
import { checkInputValidity } from '../../lib/funnels/functions/v1/html/checkInputValidity'
import { setUpFormInputs } from '../../lib/funnels/functions/v1/html/setupFormInputs'
import { submitSpinner } from '../../lib/funnels/functions/v1/default/submitSpinner'
import { resetSubmitSpinner } from '../../lib/funnels/functions/v1/default/resetSubmitSpinner'
import { getFunnelCache } from '../../lib/funnels/functions/v1/default/getFunnelCache'
import { leadDataToParam } from '@turbodebt/turbo-shared'
import { submitForm } from '../../lib/funnels/functions/v1/submit/submitForm'
import { getTrustedFormFields } from '../../lib/funnels/functions/v1/default/getTrustedFormFields'
import { setTCPAText } from '../../lib/funnels/functions/v1/html/setTCPAText'
import { captureLoaded } from '../../lib/funnels/functions/v1/metrics/captureLoaded'
import { captureSubmitClick } from '../../lib/funnels/functions/v1/submit/captureSubmitClick'
import { captureSubmitEvent } from '../../lib/funnels/functions/v1/submit/captureSubmitEvent'

import './shared.css'

document.addEventListener('DOMContentLoaded', () => {
  setTCPAText()

  captureLoaded()

  const SESSION_ID = 'tdMainFunnel'
  queryParamsToSession(SESSION_ID)

  setUpFormInputs()

  const funnelFromParam = getSessionValue(SESSION_ID, 'funnel')
  if (!funnelFromParam) {
    const funnel = getFunnelFromUrl()
    updateSession(SESSION_ID, 'funnel', funnel)
  } else {
    updateSession(SESSION_ID, 'website', funnelFromParam)
  }

  const debtOwed = getSessionValue(SESSION_ID, 'debtOwed')
  if (!debtOwed) {
    updateSession(SESSION_ID, 'debtOwed', '7500')
  }

  // name field
  const nameInput = /** @type {HTMLInputElement | null} */ (
    document.getElementById('name')
  )
  // email field
  const emailInput = /** @type {HTMLInputElement | null} */ (
    document.getElementById('email')
  )
  // phone field
  const phoneInput = /** @type {HTMLInputElement | null} */ (
    document.getElementById('phone')
  )

  const form = /** @type {HTMLFormElement | null} */ (
    document.getElementById('form')
  )

  if (!form) {
    throw new Error('form or input not found')
  }

  /** @type {FormSubmitFieldArray} */
  const requiredInputs = []
  requiredInputs.push('name')
  requiredInputs.push('email')
  requiredInputs.push('phone')

  const submitButton = /** @type {HTMLButtonElement | null} */ (
    document.getElementById('button-submit')
  )

  /** @type {NodeListOf<HTMLInputElement>} */
  const formInputs = form.querySelectorAll('input[required]')

  function updateButtonColor() {
    if (!submitButton || !form) return

    let allValid = true

    formInputs.forEach((input) => {
      const value = input.value.trim()

      if (!value || !checkInputValidity(input)) {
        allValid = false
      }
    })

    submitButton.classList.toggle('valid', allValid)
  }

  function setupInputListeners() {
    formInputs.forEach((input) => {
      input.addEventListener('input', () => {
        updateButtonColor()
      })
    })
  }

  setupInputListeners()

  form.addEventListener('submit', async (event) => {
    event.preventDefault()

    captureSubmitClick()

    let isValidForm = true
    const detail = getDataFromSubmitEvent(event)

    const invalidInputs = checkSubmitInputs(detail, requiredInputs)

    if (invalidInputs.length > 0) {
      console.error('invalid fields:', [...invalidInputs].join())

      isValidForm = false
    }

    if (!isValidForm) {
      return
    }

    let xxTrustedFormCertUrl = ''
    try {
      const trustedFormData = getTrustedFormFields('form')
      xxTrustedFormCertUrl = trustedFormData.xxTrustedFormCertUrl || ''
    } catch {
      console.warn('TrustedForm fields not found')
    }

    const nameValue = nameInput?.value.trim()
    const emailValue = emailInput?.value || ''
    const phoneValue = phoneInput?.value || ''

    if (!nameValue || !emailValue || !phoneValue) {
      return
    }

    // Phone formatting - strip formatting before submission
    if (phoneInput) {
      const strippedPhone = stripPhone(phoneInput.value)
      phoneInput.value = strippedPhone
      // Update the detail object with the stripped phone number
      detail.phone = strippedPhone
      updateSession(SESSION_ID, 'phone', strippedPhone)
    }

    updateSession(SESSION_ID, 'name', nameValue)
    updateSession(SESSION_ID, 'email', emailValue)

    const sessionCache = getFunnelCache(SESSION_ID) || {}
    const base64Param = leadDataToParam({ ...detail, ...sessionCache })
    const thanksUrl = `https://funnels.turbodebt.com/thanks/?params=${base64Param}`
    updateSession(SESSION_ID, 'thanksUrl', thanksUrl)

    try {
      if (submitButton) {
        submitSpinner(submitButton)
      }

      const payload = {
        debtOwed: '10000',
        name: nameValue,
        email: emailValue,
        phone: stripPhone(phoneValue),
        xxTrustedFormCertUrl,
      }

      captureSubmitEvent()
      // post name, email, & phone to middleware form-submit
      const redirectUrl = await submitForm(payload)

      // save chat link and go to next screen for credit pull
      updateSession(SESSION_ID, 'returnLink', redirectUrl)
    } catch (e) {
      console.error('error', e)
    } finally {
      resetSubmitSpinner(submitButton)
      window.location.href = '/getting-started/submit/'
    }
  })
})
